
import React, { useState } from "react";
import { Input, Button } from "antd";
import "./ResetPassword.css"; // Custom styles for the component
import logo from '../login/Logo.jpg'; // Import the logo

const  ResetPassword = () => {
  const [code, setCode] = useState(new Array(6).fill(""));

  const handleInputChange = (value, index) => {
    if (/^[0-9]*$/.test(value)) {
      const newCode = [...code];
      newCode[index] = value;
      setCode(newCode);

      // Move to the next input if a digit is entered
      if (value && index < 5) {
        const nextInput = document.getElementById(`input-${index + 1}`);
        if (nextInput) {
          nextInput.focus();
        }
      }
    }
  };

  const handleKeyPress = (e, index) => {
    if (e.key === "Backspace" && !code[index] && index > 0) {
      const prevInput = document.getElementById(`input-${index - 1}`);
      if (prevInput) {
        prevInput.focus();
      }
    }
  };

  const handleSubmit = () => {
    const verificationCode = code.join("");
    console.log("Verification Code:", verificationCode);
    // Perform the API call or verification logic here
  };

  return (
    <div className="verification-card">
      <div className="verification-container">
        <img src={logo} alt="Surveyor's AI" className="verification-logo" />
        <h2 className="verification-title">Sign in with verification code</h2>
        <p className="verification-subtext">
          We have sent a 6-digit code to ***@gmail.com
        </p>
        <div className="code-input-container">
          {code.map((digit, index) => (
            <Input
              key={index}
              id={`input-${index}`}
              className="code-input"
              maxLength={1}
              value={digit}
              onChange={(e) => handleInputChange(e.target.value, index)}
              onKeyDown={(e) => handleKeyPress(e, index)}
            />
          ))}
        </div>
        <Button
          type="primary"
          className="verification-button"
          onClick={handleSubmit}
        >
          Login
        </Button>
      </div>
    </div>
  );
};




export default ResetPassword;
